import { LPSettlementBatchStatusEnum } from '@talos/kyoko';
import { LPSettlementBatchesGrid } from '../LPSettlementBatchesGrid/LPSettlementBatchesGrid';

const ACTIVE_BATCH_STATUSES: LPSettlementBatchStatusEnum[] = [
  LPSettlementBatchStatusEnum.Created,
  LPSettlementBatchStatusEnum.InProgress,
];

export function ActiveBatches() {
  return (
    <LPSettlementBatchesGrid
      blotterID="active-batches"
      BatchStatuses={ACTIVE_BATCH_STATUSES}
      exportName="Active Batches"
      mode="activeBatches"
    />
  );
}
